<template>
  <VCard class="elevation-12">
    <VToolbar
      dark
      color="primary"
    >
      <VToolbarTitle>Enter Validation Code</VToolbarTitle>
    </VToolbar>
    <VCardText>
      <VForm
        ref="form"
        v-model="form"
        @submit="handleAuthyCheck"
      >
        <VTextField
          v-model="code"
          :rules="codeRules"
          prepend-icon="vpn_key"
          name="code"
          label="Validation Code"
          type="text"
        />
        <VCardActions>
          <VBtn
            :loading="requestPhoneVerificationLoading"
            color="success"
            @click.prevent="handleResend"
          >
            Resend
          </VBtn>
          <VSpacer />
          <VBtn
            :loading="checkPhoneVerificationLoading"
            :disabled="!form"
            color="primary"
            type="submit"
            @click.prevent="handleAuthyCheck"
          >
            Verify
          </VBtn>
        </VCardActions>
      </VForm>
    </VCardText>
    <NetworkSnackBar />
  </VCard>
</template>

<script>
import { mapGetters } from 'vuex'
import NetworkSnackBar from './NetworkSnackBar'
export default {
  name: 'PhoneVerificationCheckCard',
  components: { NetworkSnackBar },
  data: () => ({
    form: false,
    code: '',
    codeRules: [
      v => !!v || 'Required.',
      v => /^\d+/.test(v) || 'Code must be valid'
    ]
  }),
  computed: {
    ...mapGetters({
      requestPhoneVerificationLoading: 'account/getRequestPhoneVerificationLoading',
      checkPhoneVerificationLoading: 'account/getCheckPhoneVerificationLoading',
      requestPhoneNumber: 'account/getRequestPhoneNumber'
    })
  },
  methods: {
    handleAuthyCheck () {
      const { code } = this
      const { dispatch } = this.$store
      if (this.$refs.form.validate()) {
        dispatch('alert/clear')
          .then(() => dispatch('account/checkPhoneVerification', { phoneNumber: this.requestPhoneNumber, code }))
      }
    },
    handleResend () {
      const { dispatch } = this.$store
      dispatch('alert/clear')
        .then(() => dispatch('account/requestPhoneVerification', { phoneNumber: this.requestPhoneNumber }))
    }
  }
}
</script>

<style scoped>

</style>
